(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product-detail-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ppd2').forEach(function(root){
  try {
    var wrap = root.querySelector('[data-ppd2-options-wrap]');
    var variantsEl = wrap ? wrap.querySelector('[data-ppd2-variants]') : null;
    var optionsEl = wrap ? wrap.querySelector('[data-ppd2-options]') : null;

    var availEl = root.querySelector('[data-ppd2-availability]');
    var heroImgEl = root.querySelector('[data-ppd2-hero]');

    var variants = [], optionsWithValues = [], selected = [], maxOptions = 0;
    if (variantsEl && optionsEl){
      variants = JSON.parse(variantsEl.textContent);
      optionsWithValues = JSON.parse(optionsEl.textContent);
      maxOptions = Math.min(optionsWithValues.length, 3);
    }

    function findVariant(){
      if (!variants.length) return null;
      return variants.find(function(v){
        for (var i = 0; i < maxOptions; i++){
          if (v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function currentSelectionLines(){
      var lines = [];
      root.querySelectorAll('[data-ppd2-real-options] .ppd2-variant-block').forEach(function(block){
        var label = block.querySelector('.ppd2-variant-label');
        if (!label) return;
        var nameSpan = label.querySelector('span:first-child');
        var valueSpan = label.querySelector('[data-value-display]');
        if (nameSpan && valueSpan && valueSpan.textContent.trim()){
          lines.push(nameSpan.textContent.trim() + ': ' + valueSpan.textContent.trim());
        }
      });
      return lines;
    }

    function updateForVariant(){
      var variant = findVariant();
      if (!variant) return;
      if (availEl) availEl.textContent = variant.available ? 'In stock' : 'Made to order';
      if (variant.featured_image && heroImgEl){
        heroImgEl.src = variant.featured_image.src;
        root.querySelectorAll('[data-ppd2-thumb]').forEach(function(t){
          t.classList.toggle('is-active', t.dataset.full.split('?')[0] === variant.featured_image.src.split('?')[0]);
        });
      }
    }

    // ---- build Material (dropdown) / Color (swatches) / Finish (buttons) ----
    // Material ALWAYS renders first. Every other option's availability is
    // recalculated against whatever Material (and any other prior selection)
    // is currently chosen — so Color/Finish are always a subset determined
    // by the selected Material, never an independent, unfiltered list.
    try {
      var realOptionsWrap = root.querySelector('[data-ppd2-real-options]');
      var optionElements = [];

      function comboExists(idx, val){
        return variants.some(function(v){
          if (v.options[idx] !== val) return false;
          for (var i = 0; i < maxOptions; i++){
            if (i === idx) continue;
            if (selected[i] != null && v.options[i] !== selected[i]) return false;
          }
          return true;
        });
      }

      function refreshOptionAvailability(){
        optionElements.forEach(function(entry){
          var stillValid = comboExists(entry.idx, entry.val);
          entry.el.disabled = !stillValid;
          entry.el.classList.toggle('is-unavailable', !stillValid);
        });
        optionElements.forEach(function(entry){
          if (entry.val === selected[entry.idx] && entry.el.disabled){
            var fallback = optionElements.find(function(e){ return e.idx === entry.idx && !e.el.disabled; });
            if (fallback) fallback.el.click();
          }
        });
      }

      if (realOptionsWrap && optionsWithValues.length){
        var order = ['material', 'color', 'finish'];
        var ordered = [];
        order.forEach(function(name){
          var idx = optionsWithValues.findIndex(function(o){ return o.name.toLowerCase() === name; });
          if (idx > -1 && idx < maxOptions) ordered.push({ opt: optionsWithValues[idx], idx: idx });
        });
        optionsWithValues.slice(0, maxOptions).forEach(function(opt, idx){
          if (!order.includes(opt.name.toLowerCase())) ordered.push({ opt: opt, idx: idx });
        });

        ordered.forEach(function(entry){
          var opt = entry.opt, idx = entry.idx;
          selected[idx] = opt.values[0];
          var nameLower = opt.name.toLowerCase();
          var isMaterial = nameLower === 'material';
          var isColor = nameLower === 'color';

          var block = document.createElement('div');
          block.className = 'ppd2-variant-block';

          var label = document.createElement('div');
          label.className = 'ppd2-variant-label';
          label.innerHTML = '<span>' + opt.name + '</span><span data-value-display>' + opt.values[0] + '</span>';
          block.appendChild(label);

          if (isMaterial){
            var select = document.createElement('select');
            select.className = 'ppd2-select';
            opt.values.forEach(function(val){
              var o = document.createElement('option');
              o.value = val; o.textContent = val;
              select.appendChild(o);
            });
            select.addEventListener('change', function(){
              selected[idx] = select.value;
              label.querySelector('[data-value-display]').textContent = select.value;
              refreshOptionAvailability();
              updateForVariant();
            });
            block.appendChild(select);
            realOptionsWrap.appendChild(block);
            return;
          }

          var row = document.createElement('div');
          row.className = isColor ? 'ppd2-swatch-row' : 'ppd2-pill-row';

          var COLOR_FALLBACK = {
            'white':'#EFEDE7','blue':'#3E6E96','green':'#1B3B2F','forest green':'#1B3B2F',
            'charcoal':'#2B2A28','black':'#16151A','red':'#7A2E2E','grey':'#8A8A82','gray':'#8A8A82',
            'natural oak':'#C9A26B','walnut':'#5B3C22','smoked walnut':'#3A2A1C','ebonized oak':'#22201D',
            'white oak':'#D9CBAE'
          };

          opt.values.forEach(function(val, vIdx){
            var matchingVariant = variants.find(function(v){ return v.options[idx] === val; });
            var hasPhoto = matchingVariant && matchingVariant.featured_image;
            var el;

            if (isColor){
              el = document.createElement('button');
              el.type = 'button';
              el.className = 'ppd2-photo-swatch' + (vIdx === 0 ? ' is-selected' : '');
              if (hasPhoto){
                el.style.backgroundImage = 'url(' + matchingVariant.featured_image.src + ')';
              } else {
                el.style.background = COLOR_FALLBACK[val.toLowerCase().trim()] || '#DAD6CC';
              }
            } else {
              el = document.createElement('button');
              el.type = 'button';
              el.className = 'ppd2-pill' + (vIdx === 0 ? ' is-selected' : '');
              el.textContent = val;
            }
            el.dataset.value = val;
            el.title = val;

            optionElements.push({ idx: idx, val: val, el: el });

            el.addEventListener('click', function(){
              if (el.disabled) return;
              row.querySelectorAll('.is-selected').forEach(function(s){ s.classList.remove('is-selected'); });
              el.classList.add('is-selected');
              selected[idx] = val;
              label.querySelector('[data-value-display]').textContent = val;
              refreshOptionAvailability();
              updateForVariant();
            });
            row.appendChild(el);
          });

          block.appendChild(row);
          realOptionsWrap.appendChild(block);
        });

        refreshOptionAvailability();
        updateForVariant();
      }
    } catch (optErr) {
      console.error('[Premium Product Detail] could not render options:', optErr);
      var realOptionsWrapFallback = root.querySelector('[data-ppd2-real-options]');
      if (realOptionsWrapFallback && !realOptionsWrapFallback.children.length){
        realOptionsWrapFallback.innerHTML = '<div style="font-size:12px;color:#B00;">Options failed to load — check the browser console for details.</div>';
      }
    }

    // ---- accordions ----
    root.querySelectorAll('[data-ppd2-tab-head]').forEach(function(head){
      head.addEventListener('click', function(){
        head.closest('.ppd2-accordion-item').classList.toggle('is-open');
      });
    });

    // ---- thumbnail strip ----
    root.querySelectorAll('[data-ppd2-thumb]').forEach(function(thumb){
      thumb.addEventListener('click', function(){
        root.querySelectorAll('[data-ppd2-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (heroImgEl) heroImgEl.src = thumb.dataset.full;
      });
    });

    // ---- external page/URL quote button: carry the current selection as query params ----
    root.querySelectorAll('[data-ppd2-external-quote]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var baseUrl = btn.dataset.baseUrl || '#';
        var productTitle = btn.dataset.productTitle || '';
        var lines = currentSelectionLines();

        var params = new URLSearchParams();
        if (productTitle) params.set('product', productTitle);
        if (lines.length) params.set('configuration', lines.join(', '));

        var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
        var fullUrl = baseUrl + (params.toString() ? separator + params.toString() : '');
        window.open(fullUrl, '_blank', 'noopener');
      });
    });

    // ---- quote modal: collect name/phone/email, pre-fill with current selections ----
    root.querySelectorAll('[data-ppd2-quote-open]').forEach(function(openBtn){
      var container = openBtn.parentElement;
      var overlay = container.querySelector('[data-ppd2-modal-overlay]');
      if (!overlay) return;
      var summaryEl = overlay.querySelector('[data-ppd2-modal-summary]');
      var formEl = overlay.querySelector('[data-ppd2-quote-form]');
      var closeBtn = overlay.querySelector('[data-ppd2-modal-close]');
      var formView = overlay.querySelector('[data-ppd2-modal-form-view]');
      var successView = overlay.querySelector('[data-ppd2-modal-success-view]');
      var successText = overlay.querySelector('[data-ppd2-modal-success-text]');
      var doneBtn = overlay.querySelector('[data-ppd2-modal-done]');
      var productTitle = openBtn.dataset.productTitle || document.title;

      function renderSelectionBox(){
        var lines = currentSelectionLines();
        if (!lines.length){
          summaryEl.innerHTML = '';
          return;
        }
        var html = '<strong>Your selection</strong><br>' + lines.join('<br>');
        summaryEl.innerHTML = html;
      }

      function showForm(){
        formView.hidden = false;
        successView.hidden = true;
      }
      function showSuccess(name){
        formView.hidden = true;
        successView.hidden = false;
        successText.textContent = (name ? name + ', your' : 'Your') +
          ' quote request has been sent to the Favero team. They will follow up with you shortly.';
      }

      function openModal(){
        renderSelectionBox();
        showForm();
        if (formEl) formEl.reset();
        var errEl = overlay.querySelector('[data-ppd2-modal-error]');
        if (errEl){ errEl.hidden = true; errEl.textContent = ''; }
        overlay.hidden = false;
      }
      function closeModal(){ overlay.hidden = true; }

      openBtn.addEventListener('click', openModal);
      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      if (doneBtn) doneBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function(e){ if (e.target === overlay) closeModal(); });

      var backendUrl = openBtn.dataset.backendUrl || '';
      var errorEl = overlay.querySelector('[data-ppd2-modal-error]');
      var submitBtn = overlay.querySelector('.ppd2-modal-submit');
      var bodyField = overlay.querySelector('[data-ppd2-contact-body]');

      function buildBodyText(lines){
        return ['Product: ' + productTitle, 'Configuration:']
          .concat(lines.length ? lines : ['(no options selected)'])
          .join('\n');
      }

      function sendViaNativeForm(name, lines){
        if (errorEl){ errorEl.hidden = true; errorEl.textContent = ''; }
        if (submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

        fetch(formEl.action, { method: 'POST', body: new FormData(formEl) })
          .then(function(r){
            if (!r.ok) throw new Error('Request failed (' + r.status + ')');
            if (submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Send Request'; }
            showSuccess(name);
          })
          .catch(function(err){
            console.error('[Premium Product Detail] quote submission failed:', err);
            if (submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Send Request'; }
            if (errorEl){
              errorEl.hidden = false;
              errorEl.textContent = 'Something went wrong sending your request. Please try again, or contact us directly.';
            }
          });
      }

      function sendViaBackend(name, phone, email, lines){
        if (errorEl){ errorEl.hidden = true; errorEl.textContent = ''; }
        if (submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Sending...'; }

        fetch(backendUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            name: name, phone: phone, email: email,
            product: productTitle,
            configuration: lines
          })
        })
          .then(function(r){
            if (!r.ok) throw new Error('Request failed (' + r.status + ')');
            return r.json().catch(function(){ return {}; });
          })
          .then(function(){
            if (submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Send Request'; }
            showSuccess(name);
          })
          .catch(function(err){
            console.error('[Premium Product Detail] quote submission failed:', err);
            if (submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Send Request'; }
            if (errorEl){
              errorEl.hidden = false;
              errorEl.textContent = 'Something went wrong sending your request. Please try again, or email us directly.';
            }
          });
      }

      if (formEl){
        formEl.addEventListener('submit', function(e){
          e.preventDefault();
          var fd = new FormData(formEl);
          var name = (fd.get('contact[name]') || '').toString().trim();
          var phone = (fd.get('contact[Phone]') || '').toString().trim();
          var email = (fd.get('contact[email]') || '').toString().trim();
          var lines = currentSelectionLines();

          if (bodyField) bodyField.value = buildBodyText(lines);

          if (backendUrl){
            sendViaBackend(name, phone, email, lines);
          } else {
            sendViaNativeForm(name, lines);
          }
        });
      }
    });

  } catch (err) {
    console.error('[Premium Product Detail] section failed to initialize:', err);
  }
});

  } catch(e) { console.error(e); }
})();
})();
